<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات برنامه ورزشی"
        >
          <b-form
            @submit.prevent
          >
            <b-row>
              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col
                    class="image"
                    cols="6"
                  >
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="شناسه"
                      label-for="Percent"
                    >
                      <b-form-input
                        id="IdInStore"
                        v-model="Form.IdInStore"
                        name="IdInStore"
                        autocomplete="off"
                        type="number"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="گروه"
                      label-for="ActivityGroupId"
                    >
                      <z-activity-group
                        v-model="Form.ActivityGroupId"
                        :multiple="false"
                        :clearable="false"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="درصد"
                      label-for="Percent"
                    >
                      <b-form-input
                        id="Percent"
                        v-model="Form.Percent"
                        name="Percent"
                        autocomplete="off"
                        type="number"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="وضعیت"
                      label-for="ActivationType"
                    >
                      <v-select
                        v-model="Form.ActivationType"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="ActivationType"
                        :clearable="false"
                        :options="enums('ActivationType')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    class="mt-1 mb-1"
                  >
                    <b-form-group>
                      <b-form-checkbox
                        v-model="Form.JustFullSale"
                        name="JustFullSale"
                        value="true"
                        class="custom-control-success"
                      >
                        این برنامه ورزشی به صورت کامل فروخته می شود و امکان خرید تکی دوره وجود ندارد!
                      </b-form-checkbox>

                      <b-form-checkbox
                        v-if="Form.JustFullSale === false"
                        v-model="Form.JustFullSale"
                        name="JustFullSale"
                        value="false"
                        style="display: none;"
                      />

                    </b-form-group>
                  </b-col>

                  <b-col
                    md="6"
                    class="mb-1"
                  >
                    <fm-file-select
                      v-model="Form.Image"
                      label="تصویر پیشنمایش"
                      :entity="1"
                    />
                  </b-col>
                  <b-col
                    md="6"
                    class="mb-1"
                  >
                    <fm-file-select
                      v-model="Form.Video"
                      type="video"
                      label="ویدیو پیشنمایش"
                      :entity="1"
                    />
                  </b-col>

                  <b-col cols="12">
                    <b-row
                      v-for="(item, index) in ActivityPackageLanguage"
                      :key="`item${index}`"
                    >
                      <b-col cols="12">
                        <hr>
                      </b-col>

                      <b-col md="5">
                        <b-form-group
                          label="زبان"
                        >
                          <z-language
                            v-model="item.Language"
                            :unselectable="ActivityPackageLanguage.map(x => x.Language)"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="5">
                        <b-form-group
                          label="عنوان"
                        >
                          <b-form-input
                            v-model="item.Title"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col
                        md="2"
                        class="mb-1"
                        style="display: flex; align-items: flex-end;"
                      >
                        <template v-if="ActivityPackageLanguageRemoveId !== index">
                          <b-button
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="removeActivityPackageLanguage(index)"
                          >
                            <feather-icon
                              icon="TrashIcon"
                            />
                          </b-button>
                        </template>
                        <template v-else>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle"
                            variant="outline-primary"
                            @click="cancelActivityPackageLanguage"
                          >
                            <feather-icon icon="XIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle ml-1"
                            variant="outline-primary"
                            @click="confirmActivityPackageLanguage"
                          >
                            <feather-icon icon="CheckIcon" />
                          </b-button>
                        </template>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group
                          label="توضیحات"
                        >
                          <b-form-textarea
                            id="Description"
                            v-model="item.Description"
                            name="Description"
                            autocomplete="off"
                            rows="4"
                            no-resize
                          />
                        </b-form-group>
                      </b-col>

                    </b-row>
                  </b-col>

                  <b-col>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      class="mt-1"
                      @click="addActivityPackageLanguage"
                    >
                      <feather-icon
                        icon="PlusIcon"
                      />
                      <span>دوره</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZActivityGroup from '@/tools/activitygroup.vue'
import FmFileSelect from '@/views/menu/file-manager/components/fmFileSelect.vue'

export default {
  name: 'ActivityPackageDetails',
  components: {
    ZActivityGroup,
    FmFileSelect,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        IdInStore: null,
        ActivationType: 1,
        Video: null,
        Image: null,
        Percent: 0,
        ActivityGroupId: null,
        JustFullSale: false,
      },
      ActivityPackageLanguage: [],
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 0,
      },
      ActivityPackageLanguageRemoveId: null,
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    } else {
      this.addActivityPackageLanguage()
    }
  },
  methods: {
    save() {
      let url = this.$api.activitypackage.add
      if (this.$route.params.id) {
        url = this.$api.activitypackage.update
      }
      const payload = {
        ...this.Form,
        ActivityPackageLanguage: (this.ActivityPackageLanguage || [])
          .filter(item => typeof item.Language === 'number'),
      }
      this.loading = true
      this.$http.post(url, payload)
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.activitypackage.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          const { ActivityPackageLanguage, ...rest } = res.data
          this.Form = rest
          this.ActivityPackageLanguage = ActivityPackageLanguage
        })
    },
    addActivityPackageLanguage() {
      this.ActivityPackageLanguage.push({
        Title: null, Language: null, Description: '',
      })
    },
    removeActivityPackageLanguage(index) {
      this.ActivityPackageLanguage.splice(index, 1)
    },
    confirmActivityPackageLanguage() {
      this.ActivityPackageLanguage.splice(this.ActivityPackageLanguageRemoveId, 1)
      this.ActivityPackageLanguageRemoveId = null
    },
    cancelActivityPackageLanguage() {
      this.ActivityPackageLanguageRemoveId = null
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
